import { call, put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { selectProductPriceCategory } from 'features/product-info';
import { selectProductBelong, selectProductId, selectProductName, selectProductPrice } from './selectors';
import { GaProductBelong } from './types';

/**
 * Событие должно срабатывать при клике на кнопку "Рассчитать количество"
 */

export const CALCULATE_QUANTITY_GA = createAction('CALCULATE_QUANTITY_GA')<{
  elementText: string;
}>();

export const gaCalculateQuantity = createAction('GA:clickButton')<{
  elementType: 'product';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementText: string;
  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productTag: string; // bestPrice для “Лучшей цены” и onlineOnly для “Только онлайн заказ”, а также остальные бейджи. При наличии нескольких передавать через разделитель “,”
  productBelong: GaProductBelong; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
}>();

export function* putGaCalculateQuantity(elementText: string) {
  yield put(
    gaCalculateQuantity({
      elementType: 'product',
      elementBlock: 'productDetail',
      elementText,
      productName: yield call(selectProductName),
      productId: yield call(selectProductId),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productTag: yield call(selectProductPriceCategory),
    }),
  );
}

export function* runCalculateQuantityDetector() {
  yield takeEvery(CALCULATE_QUANTITY_GA, ({ payload: { elementText } }) =>
    putGaCalculateQuantity(elementText),
  );
}
